import * as React from 'react';
import {Storage, translate} from 'react-jhipster';
import Divider from '@mui/material/Divider';
import moment from 'moment/moment';
import {IQuotation} from 'app/shared/model/quotation.model';
import {
  generateInvoiceNumber,
  getStaffFullName,
  numberToWords
} from 'app/shared/util/quotation-utils';
import {formatCurrency} from 'app/shared/util/currency-utils';
import {INVOICE_CONSTANTS, STYLE_RULES} from 'app/entities/quotation/components/invoice';
import './invoice-template.scss';

type Props = {
  captureRef?:any
  quotationEntity:IQuotation;
};
export const InvoicePrint = (props: Props) => {
  const {captureRef,quotationEntity} = props;

  React.useEffect(() => {
    const printContent = document.getElementById('contentToPrint');
    if (!printContent) return;

    STYLE_RULES.forEach(({ selector, styles }) => {
      const elements = printContent.querySelectorAll(selector);
      elements.forEach((element) => {
        Object.entries(styles).forEach(([property, value]) => {
          (element as HTMLElement).style.setProperty(property, value, 'important');
        });
      });
    });
  }, [quotationEntity]);

  return (
    <>
      <div
        ref={captureRef}
        id="contentToPrint"
        className="boubyan-invoice"
        dir="ltr"
        style={{
          position: 'relative',
          width: '794px',
          height: '1123px',
          overflow: 'hidden',
          boxShadow: '0 0 40px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'transparent',
          margin: '20px auto',
          direction: 'ltr !important' as any,
          isolation: 'isolate'
        }}
      >
        <div id="headerPrint" className="header-print">
          <div className="header-container">
            <div className="header-left">
              <img src="../content/images/boubyan-logo.png" width="180px" alt="Logo"/>
            </div>
            {/* <div className="header-right">*/}
            {/*  <p className="header-title">*/}
            {/*    {translate('comexApp.quotation.invoice.alshmokhHolding')}*/}
            {/*  </p>*/}
            {/* </div> */}
          </div>
        </div>

        {/* <Divider sx={{borderBottomWidth: 3, marginLeft: '48px', marginRight: '48px', color: '#01579b'}}/> */}

        <div className="info-section">
          <table className="info-table">
            <thead>
            <tr>
              <th>{INVOICE_CONSTANTS.BANK_NAME}</th>
              <th>{INVOICE_CONSTANTS.CLIENT_NAME}</th>
              <th>{INVOICE_CONSTANTS.BRANCH_NAME}</th>
              <th>{INVOICE_CONSTANTS.BANK_REPRESENTATIVE}</th>
            </tr>
            </thead>
            <tbody>
            <tr className="arabic-row">
              <td className="arabic">{INVOICE_CONSTANTS.BANK_NAME_AR}</td>
              <td className="arabic">{INVOICE_CONSTANTS.CLIENT_NAME_AR}</td>
              <td className="arabic">{INVOICE_CONSTANTS.BRANCH_NAME_AR}</td>
              <td className="arabic">{INVOICE_CONSTANTS.BANK_REPRESENTATIVE_AR}</td>
            </tr>
            <tr>
              <td>{quotationEntity?.bank?.name || ''}</td>
              <td>
                {quotationEntity?.commodity?.ownership === 'Local' && quotationEntity?.customer?.nameArabic ? quotationEntity?.customer?.nameArabic : quotationEntity?.customer?.name || ''}
              </td>
              <td>{quotationEntity?.branch?.name || ''}</td>
              <td>{getStaffFullName(quotationEntity?.createdUser)}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div className="invoice-header">
          <div className="invoice-left">Invoice</div>
          <div className="invoice-center">{generateInvoiceNumber(quotationEntity)}</div>
          <div className="invoice-right arabic">{INVOICE_CONSTANTS.INVOICE_AR}</div>
        </div>

        <div className="invoice-meta-container">
          <div className="invoice-meta-box">
            <div className="invoice-meta-col english-labels">
              <p className="invoice-meta-text">{INVOICE_CONSTANTS.INVOICE_DATE}:</p>
              <p className="invoice-meta-text">{INVOICE_CONSTANTS.QUOTATION_NUMBER}:</p>
              <p className="invoice-meta-text">{INVOICE_CONSTANTS.REFERENCE}:</p>
            </div>

            <div className="invoice-meta-col value-section">
              <p className="invoice-meta-text">
                {moment(quotationEntity?.localCommodityStbCert?.createdDate || quotationEntity?.createdDate).format('DD/MM/yyyy')}
              </p>
              <p className="invoice-meta-text">{quotationEntity?.id || ''}</p>
              <p className="invoice-meta-text">{quotationEntity?.transactionRefNo || ''}</p>
            </div>

            <div className="invoice-meta-col arabic-labels">
              <p className="invoice-meta-text arabic-right">{INVOICE_CONSTANTS.INVOICE_DATE_AR}</p>
              <p className="invoice-meta-text arabic-right">{INVOICE_CONSTANTS.QUOTATION_NUMBER_AR}</p>
              <p className="invoice-meta-text arabic-right">{INVOICE_CONSTANTS.REFERENCE_AR}</p>
            </div>
          </div>
        </div>

        <div className="invoice-table-container">
          <table className="invoice-table">
            <thead>
            <tr className="header-row">
              <td className="col-total-price">
                <div className="arabic-label">{INVOICE_CONSTANTS.TOTAL_PRICE_AR}</div>
                {INVOICE_CONSTANTS.TOTAL_PRICE}
              </td>
              <td className="col-amount">
                <div className="arabic-label">{INVOICE_CONSTANTS.AMOUNT_AR}</div>
                {INVOICE_CONSTANTS.AMOUNT}
              </td>
              <td className="col-unit-price">
                <div className="arabic-label">{INVOICE_CONSTANTS.UNIT_PRICE_AR}</div>
                {INVOICE_CONSTANTS.UNIT_PRICE}
              </td>
              <td className="col-quantity">
                <div className="arabic-label">{INVOICE_CONSTANTS.QUANTITY_AR}</div>
                {INVOICE_CONSTANTS.QUANTITY}
              </td>
              <td className="col-description">
                <div className="arabic-label">{INVOICE_CONSTANTS.DESCRIPTION_AR}</div>
                {INVOICE_CONSTANTS.DESCRIPTION}
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td
                className="pink-cell">{formatCurrency(quotationEntity?.amount?.toLocaleString(), quotationEntity?.buyCurrency)}</td>
              <td
                className="pink-cell">{formatCurrency(
                quotationEntity?.amount != null
                  ? (quotationEntity.amount - ((quotationEntity.fee ?? 0) + (quotationEntity.commission ?? 0))).toLocaleString()
                  : '-',
                quotationEntity?.buyCurrency
              )}</td>
              <td>{formatCurrency(quotationEntity?.commodityUnitPrice?.toLocaleString(), quotationEntity?.buyCurrency)}</td>
              <td>{formatCurrency(quotationEntity?.commodityQuantity?.toLocaleString(), quotationEntity?.commodityUnit)}</td>
              <td>{quotationEntity?.commodity?.description}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div className="summary-table-wrapper">
          <div className="summary-table-container">
            <table className="summary-table">
              <tbody>
              <tr>
                <td className="left-cell">
                  {formatCurrency(
                    quotationEntity?.amount != null
                      ? (quotationEntity.amount - ((quotationEntity.fee ?? 0) + (quotationEntity.commission ?? 0))).toLocaleString()
                      : '-',
                    quotationEntity?.buyCurrency
                  )}
                </td>
                <td className="right-cell">
                  <span className="english-text">{INVOICE_CONSTANTS.SUB_TOTAL}</span> / <span
                  className="arabic-bold">{INVOICE_CONSTANTS.SUB_TOTAL_AR}</span>
                </td>
              </tr>
              <tr className="total-row">
                <td className="left-cell white-text">
                  {formatCurrency(quotationEntity?.amount?.toLocaleString(), quotationEntity?.buyCurrency)}
                </td>
                <td className="right-cell white-text">
                  <span className="english-text">{INVOICE_CONSTANTS.TOTAL}</span> / <span
                  className="arabic-bold">{INVOICE_CONSTANTS.TOTAL_AR}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="summary-extra-wrapper">
          <table className="summary-extra-table">
            <tr>
              <td className="label-cell">{INVOICE_CONSTANTS.AMOUNT_IN_WORDS}:</td>
            </tr>
            <tr>
              <td className="value-cell">
                {quotationEntity?.amount
                  ? Storage.session.get('locale') === 'ar-ly'
                    ? `${quotationEntity.buyCurrency || ''} ${numberToWords(Number(quotationEntity.amount))}`
                    : `${numberToWords(Number(quotationEntity.amount))} ${quotationEntity.buyCurrency || ''}`
                  : ''}
              </td>
            </tr>
            <br/><br/>
            <tr>
              <td className="label-cell">{INVOICE_CONSTANTS.COMPANY_SIGNATURE}:</td>
            </tr>
            <tr>
              <td className="arabic-label-cell">:{INVOICE_CONSTANTS.COMPANY_SIGNATURE_AR}</td>
            </tr>
          </table>
        </div>

        <div className="payment-reference-wrapper">
          <table className="payment-reference-table">
            <tr>
              <td className="left-cell">{INVOICE_CONSTANTS.PAYMENT_REFERENCE}:</td>
              <td className="center-cell">{generateInvoiceNumber(quotationEntity)}</td>
              <td className="right-cell arabic-text">:{INVOICE_CONSTANTS.PAYMENT_REFERENCE_AR}</td>
            </tr>
          </table>
        </div>

        {/* <div className="custom-divider-line"></div>*/}

        {/* <div className="footer-info">*/}
        {/*  <span>{INVOICE_CONSTANTS.PHONE_NUMBER} - </span>*/}
        {/*  <a href="https://sh-holding.com/" target="_blank"*/}
        {/*     rel="noopener noreferrer">https://sh-holding.com/</a>*/}
        {/* </div> */}

        {/* <div className="page-number">*/}
        {/*  <span>{INVOICE_CONSTANTS.PAGE}: 1 / 1</span>*/}
        {/* </div> */}

      </div>
    </>
  );
};
